import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.boundCheckScrollPosition = this.checkScrollPosition.bind(this);
    this.boundUpdateButtonPosition = this.updateButtonPosition.bind(this);
    this.isInitializing = true;
    
    this.element.addEventListener("scroll", this.boundCheckScrollPosition);
    
    // Update position first, then check scroll after a brief delay
    this.updateButtonPosition();
    
    setTimeout(() => {
      this.isInitializing = false;
      this.checkScrollPosition();
    }, 150);
    
    // Also check when content changes (useful for dynamically loaded content)
    this.observer = new MutationObserver(() => {
      // Always update position first, then check scroll
      this.updateButtonPosition();
      if (!this.isInitializing) {
        setTimeout(() => this.checkScrollPosition(), 50);
      }
    });
    
    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    });

    // Watch for changes to both aiChat and editorRightColumn elements
    this.aiChatObserver = new MutationObserver(() => {
      this.updateButtonPosition();
      if (!this.isInitializing) {
        setTimeout(() => this.checkScrollPosition(), 50);
      }
    });
    
    const aiChatElement = document.getElementById('aiChat');
    const editorRightColumn = document.getElementById('editorRightColumn');
    
    if (aiChatElement) {
      this.aiChatObserver.observe(aiChatElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
    if (editorRightColumn) {
      this.aiChatObserver.observe(editorRightColumn, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  get scrollButton() {
    return document.querySelector('.scroll-to-bottom-btn');
  }

  disconnect() {
    this.element.removeEventListener("scroll", this.boundCheckScrollPosition);
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.aiChatObserver) {
      this.aiChatObserver.disconnect();
    }
  }

  checkScrollPosition() {
    const scrollButton = this.scrollButton;
    if (!scrollButton) {
      return;
    }

    // Don't change visibility during initialization
    if (this.isInitializing) {
      return;
    }

    const threshold = 100; // px from bottom before showing the button
    const scrollTop = this.element.scrollTop;
    const scrollHeight = this.element.scrollHeight;
    const clientHeight = this.element.clientHeight;
    
    // Check if there's actually content to scroll
    const hasScrollableContent = scrollHeight > clientHeight;
    
    // Check if we're at the bottom
    const atBottom = scrollHeight - scrollTop <= clientHeight + threshold;

    // Check if chat is expanded - look for the element with id "aiChat"
    const aiChatElement = document.getElementById('aiChat');
    const chatIsExpanded = aiChatElement && aiChatElement.classList.contains('expanded');
    
    // Check if editor right column is visible
    const editorRightColumn = document.getElementById('editorRightColumn');
    const editorColumnVisible = editorRightColumn && editorRightColumn.classList.contains('d-lg-flex');
    
    // Show button only if either sidebar is active AND we have scrollable content AND not at bottom
    const anySidebarActive = chatIsExpanded || editorColumnVisible;
    const shouldShow = hasScrollableContent && !atBottom && anySidebarActive;
    console.log('Scroll check:', {
      scrollTop,
      scrollHeight,
      clientHeight,
      hasScrollableContent,
      atBottom,
      chatIsExpanded,
      editorColumnVisible,
      anySidebarActive,
      difference: scrollHeight - scrollTop - clientHeight
    });
    
    if (shouldShow) {
      scrollButton.classList.remove("hidden");
    } else {
      scrollButton.classList.add("hidden");
    }
  }

  updateButtonPosition() {
    const button = this.scrollButton;
    if (!button) {
      return;
    }

    const aiChatContainer = document.getElementById('ai-chat-container');
    const aiChatElement = document.getElementById('aiChat');
    const editorRightColumn = document.getElementById('editorRightColumn');
    
    // Remove all positioning classes first
    button.classList.remove('chat-sidebar-position', 'default-position');
    
    // Check if we should use sidebar positioning for either sidebar
    const chatIsExpanded = aiChatContainer && aiChatElement.classList.contains('expanded');
    const editorColumnVisible = editorRightColumn && editorRightColumn.classList.contains('d-lg-flex');
    
    // Use sidebar positioning if either sidebar is active
    const shouldUseSidebarPosition = chatIsExpanded || editorColumnVisible;
    if (editorColumnVisible) {
      button.classList.add('editor-sidebar-position');
    } else if (chatIsExpanded) {
      button.classList.add('chat-sidebar-position');
    } else {
      button.classList.add('default-position');
    }
  }

  scrollToBottom() {
    this.element.scrollTo({
      top: this.element.scrollHeight,
      behavior: 'smooth'
    });
    
    // Hide button after scrolling
    const scrollButton = this.scrollButton;
    if (scrollButton) {
      setTimeout(() => {
        scrollButton.classList.add("hidden");
      }, 300); // Small delay to account for smooth scrolling
    }
  }
}